require('./common');
import Plyr from "plyr";

// disable btns with class disabled
(function () {
    document.body.addEventListener('click', e => {
        const linkEl = e.target.closest('a');
        if (!linkEl) {
            return;
        }
        if (linkEl.classList.contains('disabled')) {
            e.preventDefault();
        }
    });
})();


class SubViewer {

    constructor(videoDetailPage, subViewerEl) {
        this.videoDetailPage = videoDetailPage;
        this.el = subViewerEl;
        this.subtitleIdEl = null;
        this.searchResults = [];
        this.currentSearchResultIndex = 0;
        this.initSelect();
        this.initBlocks();
        this.initSearch();
    }

    initSelect() {

        this.subtitleIdEl = this.el.querySelector('[name="subtitleId"]');

        const formEl = this.subtitleIdEl.closest('form');
        const btnEl = formEl.querySelector('[type="submit"]');
        btnEl.style.display = 'none';

        formEl.addEventListener('change', () => {
            this.showSubtitle();
        });

    }

    async showSubtitle() {

        const subtitleId = this.getSubtitleId();

        this.blocksEl.innerHTML = '';

        this.el.querySelector('.sub-viewer__author-wrapper').style.display = 'none';
        this.el.querySelector('.sub-viewer__translator-wrapper').style.display = 'none';

        const subtitle = await this.loadSubtitle(subtitleId);

        this.showBlocks(subtitle.blocks);

        this.el.querySelector('.sub-viewer__author').innerText = subtitle.author;
        this.el.querySelector('.sub-viewer__translator').innerText = subtitle.translator;
        if (subtitle.author) {
            this.el.querySelector('.sub-viewer__author-wrapper').style.display = '';
        }
        if (subtitle.translator) {
            this.el.querySelector('.sub-viewer__translator-wrapper').style.display = '';
        }

        this.updateCurrentBlock();

        this.search();

        updateCurrentUrlParams({ subtitleId: subtitleId });

    }

    async loadSubtitle(subtitleId) {
        const url = '/en/api/subtitles/' + subtitleId;
        const response = await axios.get(url);
        return response.data.data;
    }

    getSubtitleId() {
        return this.subtitleIdEl.options[this.subtitleIdEl.selectedIndex].value;
    }

    initBlocks() {

        this.blocksEl = this.el.querySelector('.sub-viewer__blocks');

        window.addEventListener('timechanged', e => {
            const isCurrentTab = this.el.closest('.tabs-panel.is-active');
            if (isCurrentTab) {
                this.updateCurrentBlock();
            }
        });

        this.blocksEl.addEventListener('click', e => {
            const blockEl = e.target.closest('.sub-viewer__block');
            if (!blockEl.hasAttribute('data-start')) {
                return;
            }
            this.videoDetailPage.setTime(blockEl, parseFloat(blockEl.dataset.start));
            e.preventDefault();
        });

    }

    showBlocks(blocks) {
        blocks.forEach(block => {
            const trEl = document.createElement('tr');
            this.blocksEl.appendChild(trEl);
            trEl.classList.add('sub-viewer__block');
            trEl.dataset.start = block.start;
            trEl.tabIndex = 0;
            const url = new URL(location.href);
            url.searchParams.subtitleId = this.getSubtitleId();
            const urlStr = url.toString();
            let html = '';
            html += '<td><a href="' + urlStr + '">' + secondsToTime(block.start) + '<a></td>';
            html += '<td><a href="' + urlStr + '">' + block.lines + '<a></td>';
            trEl.innerHTML = html;
        });
    }

    findCurrentBlockEl() {

        const blockEls = this.getBlockEls();

        for (let i = 0; i < blockEls.length; i ++) {
            const blockEl = blockEls[i];
            const blockStart = parseFloat(blockEl.dataset.start);
            if (blockStart > this.videoDetailPage.time) {
                return blockEls[i - 1];
            }
        }

        const lastBlockEl = blockEls[blockEls.length - 1];
        return lastBlockEl;

    }

    updateCurrentBlock() {

        const current = this.el.querySelector('.sub-viewer__block[aria-current]');
        if (current) {
            current.removeAttribute('aria-current');
        }

        const subsEl = document.querySelector('.player__subs');
        subsEl.innerText = '';

        const currentBlockEl = this.findCurrentBlockEl();
        if (currentBlockEl) {

            currentBlockEl.setAttribute('aria-current', 'time');

            const lines = this.getLinesEl(currentBlockEl).innerText;
            subsEl.innerText = lines;

            if (this.el.querySelector('[name="isSynced"]:checked')) {
                this.scrollToBlockEl(currentBlockEl);
            }

        }

    }

    initSearch() {

        this.searchEl = this.el.querySelector('[name="search"]');
        this.searchEl.addEventListener('input', debounce(async () => {
            await this.search();
        }, 300));
        this.searchEl.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
                this.goToNextSearchResult();
                e.preventDefault();
            } else if (e.key === 'Escape') {
                this.clearSearch();
                e.preventDefault();
            }
        });

        const formEl = this.searchEl.closest('form');
        formEl.addEventListener('submit', e => {
            e.preventDefault();
        });

        const nextEl = this.el.querySelector('.sub-viewer__next-search-result');
        nextEl.addEventListener('click', e => {
            this.goToNextSearchResult();
            e.preventDefault();
        });
        const prevEl = this.el.querySelector('.sub-viewer__prev-search-result');
        prevEl.addEventListener('click', e => {
            this.goToPrevSearchResult();
            e.preventDefault();
        });

        const clearBtnEl = this.el.querySelector('.sub-viewer__clear-search');
        clearBtnEl.addEventListener('click', e => {
            this.clearSearch();
            e.preventDefault();
        });

        if (this.searchEl.value.trim()) {
            this.search();
        }

    }

    async search() {
        updateCurrentUrlParams({q: this.searchEl.value.trim()});
        await this.loadSearchResults();
        this.updateSearch();
    }

    async loadSearchResults() {
        const search = this.searchEl.value.trim();
        if (!search) {
            this.searchResults = [];
            return;
        }
        const params = new URLSearchParams({
            search: search,
        });
        const url = '/en/api/subtitles/' + this.getSubtitleId() + '/search?' + params.toString();
        const response = await axios.get(url);
        this.searchResults = response.data;
    }

    updateSearch() {

        this.currentSearchResultIndex = 0;

        this.blocksEl.querySelectorAll('.viewer__block__match').forEach(blockEl => {
            const matchEl = blockEl.querySelector('.sub-viewer__match');
            matchEl.parentNode.removeChild(matchEl);
            const linesEl = this.getLinesEl(blockEl);
            let lines = linesEl.innerHTML;
            lines = lines.replace('<mark>', '');
            lines = lines.replace('</mark>', '');
            linesEl.innerHTML = lines;
            blockEl.classList.remove('viewer__block__match');
        });

        const blockEls = this.getBlockEls();
        this.searchResults.forEach(searchResult => {
            for (let i = 0; i < blockEls.length; i ++) {
                const blockEl = blockEls[i];
                const blockStart = Math.floor(parseFloat(blockEl.dataset.start));
                if (blockStart > searchResult.start) {
                    const prevBlockEl = blockEls[i - 1];
                    prevBlockEl.classList.add('viewer__block__match');
                    const linesEl = this.getLinesEl(prevBlockEl);
                    const linkEl = linesEl.querySelector('a');
                    linkEl.innerHTML = '<span class="label sub-viewer__match"></span> ' + searchResult.lines_highlighted;
                    break;
                }
            }
        });

        const numResEl = this.el.querySelector('.sub-viewer__search-status');
        numResEl.style.display = this.searchResults.length > 0 ? '' : 'none';
        if (this.searchResults.length > 0) {
            numResEl.innerHTML = '<span class="sub-viewer__current-search-result-index">1</span> / ' + this.searchResults.length;
        } else {
            numResEl.innerHTML = '';
        }

        const nextEl = this.el.querySelector('.sub-viewer__next-search-result');
        const prevEl = this.el.querySelector('.sub-viewer__prev-search-result');
        nextEl.classList.toggle('disabled', this.searchResults.length === 0);
        prevEl.classList.toggle('disabled', this.searchResults.length === 0);

        const clearBtnEl = this.el.querySelector('.sub-viewer__clear-search');
        clearBtnEl.classList.toggle('disabled', this.searchResults.length === 0);

    }

    clearSearch() {
        this.searchEl.value = '';
        this.search();
    }

    goToSearchResult() {
        const resultIndexEl = this.el.querySelector('.sub-viewer__current-search-result-index');
        if (resultIndexEl) {
            resultIndexEl.innerHTML = this.currentSearchResultIndex + 1;
        }
        const blockEls = this.blocksEl.querySelectorAll('.viewer__block__match');
        const blockEl = blockEls[this.currentSearchResultIndex];
        this.scrollToBlockEl(blockEl);
    }

    goToNextSearchResult() {
        if (this.searchResults.length === 0) {
            return;
        }
        if (this.currentSearchResultIndex < this.searchResults.length - 1) {
            this.currentSearchResultIndex ++;
        } else {
            this.currentSearchResultIndex = 0;
        }
        this.goToSearchResult();
    }

    goToPrevSearchResult() {
        if (this.currentSearchResultIndex > 0) {
            this.currentSearchResultIndex --;
        } else {
            this.currentSearchResultIndex = this.searchResults.length - 1;
        }
        this.goToSearchResult();
    }

    getBlockEls() {
        return this.blocksEl.querySelectorAll('.sub-viewer__block');
    }

    getLinesEl(blockEl) {
        return blockEl.querySelectorAll('td')[1];
    }

    scrollToBlockEl(blockEl) {
        blockEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

}

class SlidesViewer {

    constructor(videoDetailPage) {

        this.videoDetailPage = videoDetailPage;

        this.slideEls = document.querySelectorAll('.slides-viewer__slide');

        this.currentSlideEl = null;
        this.currentSlideIndex = 0;
        for (let i = 0; i < this.slideEls.length; i ++) {
            if (this.slideEls[i].hasAttribute('aria-current')) {
                this.currentSlideEl = this.slideEls[i];
                this.currentSlideIndex = i;
                break;
            }
        }

        this.prevBtn = document.querySelector('.slides-viewer__prev');
        this.nextBtn = document.querySelector('.slides-viewer__next');

        this.prevBtn.addEventListener('click', e => {
            e.preventDefault();
            if (this.currentSlideIndex === 0) {
                return;
            }
            const prevSlideEl = this.slideEls.item(this.currentSlideIndex - 1);
            this.videoDetailPage.setTime(prevSlideEl, prevSlideEl.dataset.time);
        });

        this.nextBtn.addEventListener('click', e => {
            e.preventDefault();
            if (this.currentSlideIndex === this.slideEls.length - 1) {
                return;
            }
            const nextSlideEl = this.slideEls.item(this.currentSlideIndex + 1);
            this.videoDetailPage.setTime(nextSlideEl, nextSlideEl.dataset.time);
        });

        document.querySelector('.slides-list__slides').addEventListener('click', e => {
            const slideEl = e.target.closest('.slides-list__slide');
            if (!slideEl) {
                return;
            }
            this.videoDetailPage.setTime(slideEl, slideEl.dataset.time);
            e.preventDefault();
        });

        window.addEventListener('timechanged', e => {
            this.updateCurrentSlide();
        });

    }

    updateCurrentSlide() {

        const currentListItem = document.querySelector('.slides-list__slide[aria-current]');
        if (currentListItem) {
            currentListItem.removeAttribute('aria-current');
        }

        let found = false;
        this.currentSlideIndex = 0;
        this.slideEls.forEach((slideEl, index) => {
            slideEl.removeAttribute('aria-current');
            if (!found) {
                const slideTime = parseFloat(slideEl.dataset.time);
                if (slideTime > this.videoDetailPage.time) {
                    if (index === 0) {
                        this.currentSlideIndex = 0;
                    } else {
                        this.currentSlideIndex = index - 1;
                    }
                    found = true;
                }
            }
        });

        if (!found) {
            this.currentSlideIndex = this.slideEls.length - 1;
        }

        this.currentSlideEl = this.slideEls.item(this.currentSlideIndex);
        this.currentSlideEl.setAttribute('aria-current', 'time');

        document.querySelector('.slide-viewer__current_slide_index').innerText = this.currentSlideIndex + 1;

        this.prevBtn.classList.toggle('disabled', this.currentSlideIndex === 0);
        this.nextBtn.classList.toggle('disabled', this.currentSlideIndex === this.slideEls.length - 1);

        document.querySelectorAll('.slides-list__slide')
            .item(this.currentSlideIndex)
            .setAttribute('aria-current', 'time');

    }

}

class Player {

    constructor(videoDetailPage, el) {

        this.el = el;
        this.videoDetailPage = videoDetailPage;
        this.player = new Plyr(this.el, this.getPlyrOptions());
        this.hasJumpedToInitialStartTime = false;

        this.player.once('play', () => {
            if (this.player.embed && this.player.embed.disableTextTrack === 'function') {
                this.player.embed.disableTextTrack();
            }
        });

        const params = new URLSearchParams(location.search);
        if (params.has('time')) {
            const time = parseFloat(params.get('time'));
            this.videoDetailPage.setTime(this.el, time, false);
            this.player.once('play', () => {
                if (this.hasJumpedToInitialStartTime) {
                    return;
                }
                this.player.currentTime = time;
                this.hasJumpedToInitialStartTime = true;
            });
        }

        this.player.on('timeupdate', e => {
            this.videoDetailPage.setTime(this.el, this.player.currentTime, false);
        });

        window.addEventListener('timechanged', e => {
            if (e.target.classList.contains('player__plyr') || e.target.classList.contains('plyr')) {
                return;
            }
            const time = parseFloat(e.detail.time);
            if (this.player.playing) {
                this.player.currentTime = time;
            }
        });

        Mousetrap.bindGlobal('ctrl+alt+up', () => {
            this.player.speed += 0.25;
            return false;
        });
        Mousetrap.bindGlobal('ctrl+alt+down', () => {
            this.player.speed -= 0.25;
            return false;
        });

        this.initAudioTracks();

    }

    initAudioTracks() {

        const audioPlayers = [];
        const audioTrackEls = document.querySelectorAll('.player_audio-track');
        audioTrackEls.forEach(audioTrackEl => {
            const audioPlayer = new Plyr(audioTrackEl, {
                invertTime: false,
                controls: ['play-large', 'play', 'mute', 'volume', 'current-time'],
            });
            audioPlayer.offset = parseFloat(audioTrackEl.dataset.offset);
            audioPlayers.push(audioPlayer);
        });

        this.player.on('timeupdate', e => {
            const currentTime = e.detail.plyr.currentTime;
            audioPlayers.forEach(audioPlayer => {
                if (audioPlayer.playing) {
                    const targetTime = currentTime - audioPlayer.offset;
                    const diff = targetTime - audioPlayer.currentTime;
                    if (Math.abs(diff) >= .5) {
                        audioPlayer.currentTime = targetTime;
                    }
                }
            });
        });

        this.player.on('ratechange', e => {
            audioPlayers.forEach(audioPlayer => {
                audioPlayer.speed = e.detail.plyr.speed;
            });
        });

    }

    getPlyrOptions() {
        return {
            controls: [
                'play-large',
                'rewind',
                'play',
                'fast-forward',
                'progress',
                'current-time',
                'duration',
                'mute',
                'volume',
                'captions',
                'settings',
                'fullscreen',
            ],
            i18n: {
                restart: trans('Restart'),
                rewind: trans('Rewind {seekTime}s'),
                play: trans('Play'),
                pause: trans('Pause'),
                fastForward: trans('Forward {seekTime}s'),
                seek: trans('Seek'),
                seekLabel: trans('{currentTime} of {duration}'),
                played: trans('Played'),
                buffered: trans('Buffered'),
                currentTime: trans('Current time'),
                duration: trans('Duration'),
                volume: trans('Volume'),
                mute: trans('Mute'),
                unmute: trans('Unmute'),
                enableCaptions: trans('Enable captions'),
                disableCaptions: trans('Disable captions'),
                download: trans('Download'),
                enterFullscreen: trans('Enter fullscreen'),
                exitFullscreen: trans('Exit fullscreen'),
                frameTitle: trans('Player for {title}'),
                captions: trans('Captions'),
                settings: trans('Settings'),
                menuBack: trans('Go back to previous menu'),
                speed: trans('Speed'),
                normal: trans('Normal'),
                quality: trans('Quality'),
                loop: trans('Loop'),
                start: trans('Start'),
                end: trans('End'),
                all: trans('All'),
                reset: trans('Reset'),
                disabled: trans('Disabled'),
                enabled: trans('Enabled'),
                advertisement: trans('Ad'),
                qualityBadge: {
                    2160: trans('4K'),
                    1440: trans('HD'),
                    1080: trans('HD'),
                    720: trans('HD'),
                    576: trans('SD'),
                    480: trans('SD'),
                },
            },
            keyboard: {
                focused: false,
                global: true,
            },
            // seekTime: this.seekTime,
            hideControls: false,
            fullscreen: {
                container: '.player__wrapper',
            },
        };
    }

}

class VideoDetailPage {

    constructor(el) {

        this.el = el;

        this.time = 0;

        el.querySelectorAll('.sub-viewer')
            .forEach(el => new SubViewer(this, el));

        if (el.querySelectorAll('.slides-viewer__slide').length > 0) {
            new SlidesViewer(this);
        }

        this.player = new Player(this, el.querySelector('.player__plyr'));

    }

    setTime(el, time, updateUrl = true) {

        this.time = time;

        const e = new CustomEvent('timechanged', {
            detail: {
                time: time,
            },
            bubbles: true,
        });
        el.dispatchEvent(e);

        if (updateUrl) {
            updateCurrentUrlParams({time: time });
        }

    }

}

// video detail sections
(function () {

    const wrapperEl = document.querySelector('.video-detail-sections');
    if (!wrapperEl) {
        return;
    }

    const sectionEls = wrapperEl.querySelectorAll('.video-detail-sections__section');

    const navEl = wrapperEl.querySelector('.video-detail-sections__nav');
    navEl.addEventListener('click', e => {

        navEl.querySelectorAll('a').forEach(linkEl => linkEl.removeAttribute('aria-selected'));

        navEl.querySelectorAll('li').forEach(liEl => liEl.classList.remove('is-active'));

        const linkEl = e.target;
        linkEl.setAttribute('aria-selected', true);

        const liEl = linkEl.closest('li');
        liEl.classList.add('is-active');

        const sectionId = linkEl.dataset.sectionId;
        sectionEls.forEach(sectionEl => sectionEl.classList.remove('is-active'));
        const selectedSection = wrapperEl.querySelector(`.video-detail-sections__section[data-section-id="${sectionId}"]`);
        selectedSection.classList.add('is-active');

        document.querySelector('.player__subs').innerHTML = '';

        updateCurrentUrlParams({ section: sectionId });

        e.preventDefault();

    });

})();

function updateCurrentUrlParams(newParams) {
    const params = new URLSearchParams(location.search);
    for (const [key, value] of Object.entries(newParams)) {
        params.set(key, value);
    }
    history.replaceState({}, '', '?' + params.toString());
}

// video detail page
(function () {
    const el = document.querySelector('.video-detail');
    if (!el) {
        return;
    }
    new VideoDetailPage(el);
})();
